import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationService } from 'src/app/services/translation.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent {
  constructor(
    public translationService: TranslationService,
    private permissionsService: PermissionsService
  ) {}

  users: any[] = [];
  selectedUser: any = null;
  selectedUserPermissions: { [key: string]: boolean } = {};
  successMsg: boolean = false;

  permissionsList: string[] = [
    'SettingsPermission',
    'ExamPermission',
    'ExamFolderPermission',
    'ExamSchedulPermission',
    'ExamViolationsPermission',
    'FormSetupPermission',
    'QauestionsAndAnswersPermission',
    'ReportPermission',
    'SummaryPermission',
    'AddDeletePermission'
  ];

  openAddModal: boolean = false;
  newUserName: string = '';
  newUserEmail: string = '';

  BranchesList: any[] = [];
  branchSelected: any = null;
  branchId: number = 0;
  branchName: string = '';

  ngOnInit() {
    this.permissionsService.getAllUserPermissions().subscribe((response) => {
      this.users = response.result[0];
      this.getAllBranches();
    });
  }

  onUserChange() {
    this.selectedUserPermissions = {};

    const userPerms = (this.selectedUser?.Permissions || '')
      .split(',')
      .map((p: string) => p.trim());

    this.permissionsList.forEach((perm) => {
      this.selectedUserPermissions[perm] = userPerms.includes(perm);
    });
  }

  savePermissions() {
    const granted = Object.entries(this.selectedUserPermissions)
      .filter(([_, val]) => val)
      .map(([key]) => key);
  
    const permissionsString = granted.join(',');
  
    const userID = this.selectedUser.UserID;
    
    this.permissionsService.updateUserPermissions(userID, permissionsString, this.branchId, this.branchName).subscribe({
      next: (res) => {
        this.successMsg = true;
        setTimeout(() => this.successMsg = false, 2000);
        setTimeout(() => location.reload(), 3000);
      },
    });
  }

  addModal(){
    this.openAddModal = true;
    this.newUserName = ''
    this.newUserEmail = ''
  }

  addNewUser(){
    this.permissionsService.addNewUser(this.newUserName, this.newUserEmail, this.branchId, this.branchName).subscribe({
      next: (res) => {
        this.closeModal();
      },
    });
  }

  getAllBranches(){
    this.permissionsService.getAllBranches().subscribe((response) => {
      this.BranchesList = response;
    });
  }

  getBranchSelected(){
    this.branchId = this.branchSelected.branchid;
    this.branchName = this.branchSelected.name;
  }

  closeModal(){
    this.openAddModal = false;
    this.newUserName = ''
    this.newUserEmail = ''
  }
}

